import { RatingStarRibbonBold } from '@ha/icons';
import React from 'react';
import { useIntl } from 'ha/i18n';
import { Grid, Tooltip, Typography, units, Link } from '@hbf/dsl';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  tooltip: {
    marginTop: theme.spacing(-0.8),
  },
  root: {
    padding: theme.spacing(1),
  },
  content: {
    lineHeight: 0,
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  badge: {
    color: theme.palette.orange.main,
    marginRight: theme.spacing(1),
  },
  badgeRedesign: {
    color: theme.palette.orange.main,
    marginRight: theme.spacing(1),
    fontSize: units.rem(1.1),
  },
  label: {
    whiteSpace: 'nowrap',
  },
  labelText: {
    color: theme.palette.grey[600],
  },
  description: {
    paddingLeft: theme.spacing(3.5),
  },
  link: {
    paddingLeft: theme.spacing(3.5),
    color: theme.palette.secondary.main,
  },
}));

interface Props {
  newAdvertiserDesign?: boolean;
}

const ExcellentAdvertiserBadge: React.FC<Props> = ({
  newAdvertiserDesign = false,
}) => {
  const { T, urlResolver } = useIntl();

  const { classes } = useStyles();

  if (newAdvertiserDesign) {
    return (
      <Tooltip
        placement="top"
        leaveTouchDelay={5000}
        title={
          <div
            data-test-locator="Excellent Badge Tooltip"
            className={classes.root}
          >
            <div className={classes.content}>
              <RatingStarRibbonBold
                className={classes.badgeRedesign}
                fontSize="small"
              />
              <Typography.ParagraphTitle color="default">
                {T('Excellent Advertiser')}
              </Typography.ParagraphTitle>
            </div>

            <div className={classes.description}>
              {T('excellent_advertiser_badge.tooltip.text')}
            </div>

            <Link
              target="_blank"
              className={classes.link}
              to={urlResolver.getExcellentAdverstiserBadgeExplanationLink()}
            >
              {T('excellent_advertiser_badge.tooltip.link')}
            </Link>
          </div>
        }
      >
        <Grid
          container
          justifyContent="flex-start"
          data-test-locator="Excellent Badge Content"
          wrap="nowrap"
        >
          <Grid item>
            <RatingStarRibbonBold
              className={classes.badgeRedesign}
              fontSize="small"
            />
          </Grid>
          <Grid item>
            <div className={classes.label}>
              <Typography.Caption className={classes.labelText}>
                {T('Excellent Advertiser')}
              </Typography.Caption>
            </div>
          </Grid>
        </Grid>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      placement="top"
      leaveTouchDelay={5000}
      title={
        <div
          data-test-locator="Excellent Badge Tooltip"
          className={classes.root}
        >
          <div className={classes.content}>
            <RatingStarRibbonBold className={classes.badge} fontSize="small" />
            <Typography.ParagraphTitle color="default" fontWeight="bold">
              {T('Excellent Advertiser')}
            </Typography.ParagraphTitle>
          </div>
          <div className={classes.description}>
            {T('excellent_advertiser_badge.tooltip.text')}
          </div>

          <Link
            target="_blank"
            className={classes.link}
            to={urlResolver.getExcellentAdverstiserBadgeExplanationLink()}
          >
            {T('excellent_advertiser_badge.tooltip.link')}
          </Link>
        </div>
      }
    >
      <Grid
        container
        justifyContent="center"
        data-test-locator="Excellent Badge Content"
        wrap="nowrap"
      >
        <Grid item>
          <RatingStarRibbonBold className={classes.badge} fontSize="small" />
        </Grid>
        <Grid item>
          <div className={classes.label}>
            <Typography.Caption
              color="muted"
              textTransform="uppercase"
              fontWeight="bold"
            >
              {T('Excellent Advertiser')}
            </Typography.Caption>
          </div>
        </Grid>
      </Grid>
    </Tooltip>
  );
};

export { ExcellentAdvertiserBadge };
